import React from 'react';

const GearFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 15.5c1.9 0 3.5-1.6 3.5-3.5S13.9 8.5 12 8.5 8.5 10.1 8.5 12s1.6 3.5 3.5 3.5zM14 2h-4v2.3c-.7.2-1.4.4-2.1.8L6.3 3.5 3.5 6.3l1.6 1.6c-.4.7-.6 1.4-.8 2.1H2v4h2.3c.2.7.5 1.4.9 2.1l-1.6 1.6 2.8 2.8L8 18.9c.6.4 1.3.7 2.1.9V22h4v-2.3c.7-.2 1.4-.5 2.1-.9l1.6 1.6 2.8-2.8L19 16c.4-.6.7-1.3.9-2.1H22v-4h-2.3c-.2-.7-.5-1.4-.9-2.1l1.6-1.6-2.8-2.8L16 5c-.6-.4-1.3-.7-2.1-.9V2z"
        />
    </svg>
);

GearFillSvg.displayName = 'GearFillSvg';
export default GearFillSvg;
